<model-page [model]="model" [form]="mainForm">
  <navigation-bar [model]="model" [current-index]="1"></navigation-bar>
  <p *ngIf="style=='default'">Wilt u persoonlijk advies? Vul uw contactgegevens in en klik op ‘Verzenden’, wij nemen dan zo spoedig mogelijk contact met u op.</p>
  <p *ngIf="style=='zzp'">Wenst u een adviesgesprek met een adviseur? Vul uw contactgegevens in en klik op ‘Verzenden’. Daarnaast ontvangt u, indien u onderstaande velden invult, de gemaakte premie-indicatie(s) per e-mail inclusief ondersteunende documenten en een opdrachtbevestiging om het adviestraject te starten.</p>
  <form name="mainForm" #mainForm="ngForm" class="form-horizontal">
    <fieldset>
      <legend>Advies nodig?</legend>

      <div class="form-group row">
        <div class="col-form-label col-sm-6 text-sm-right">
          <label for="name">Uw naam + voorvoegsels</label>
        </div>
        <div class="col-sm-4">
          <input id="name" name="name" #name="ngModel" class="form-control" [(ngModel)]="model.name"
                 required maxlength="70" />
          <div class="invalid-feedback" [mas-validation-message]="name"></div>
        </div>
        <div class="col-sm-2">
          <input id="prefix" name="prefix" class="form-control" [(ngModel)]="model.prefix" maxlength="10" />
        </div>
      </div>

      <form-input initials="initials" [control]="initials">
        <span form-label>Uw voorletter(s)</span>
        <input form-control id="initials" name="initials" #initials="ngModel" class="form-control" [(ngModel)]="model.initials"
               required maxlength="12" />
        <div class="invalid-feedback" [mas-validation-message]="initials"></div>
      </form-input>

      <form-input name="gender" [control]="gender">
        <span form-label>Uw geslacht</span>
        <div form-control>
          <div class="form-check form-check-inline">
            <input id="genderMale" name="gender" type="radio" class="form-check-input" #gender="ngModel" [(ngModel)]="model.gender" [value]="'M'" required>
            <label for="genderMale" class="form-check-label">Man</label>
          </div>
          <div class="form-check form-check-inline">
            <input id="genderFemale" name="gender" type="radio" class="form-check-input" [(ngModel)]="model.gender" [value]="'V'" required>
            <label for="genderFemale" class="form-check-label">Vrouw</label>
          </div>
        </div>
      </form-input>

      <form-input name="email" [control]="email">
        <span form-label>Uw e-mailadres</span>
        <input form-control type="email" id="email" name="email" #email="ngModel" class="form-control" [(ngModel)]="model.email"
               required maxlength="70" />
        <div class="invalid-feedback" [mas-validation-message]="email"></div>
      </form-input>

      <form-input name="telephoneNumber" [control]="telephoneNumber">
        <span form-label>Uw telefoonnummer</span>
        <input form-control type="tel" id="telephoneNumber" name="telephoneNumber" #telephoneNumber="ngModel" class="form-control" [(ngModel)]="model.telephoneNumber"
               required maxlength="20" pattern="^[0-9 ()+-]+$" />
        <div class="invalid-feedback" [mas-validation-message]="telephoneNumber"></div>
      </form-input>

      <form-input name="clientNumber " [control]="clientNumber" *ngIf="style=='zzp'">
        <span form-label>Uw aansluitnummer </span>
        <input form-control type="text" pattern="^[0-9]+$" id="clientNumber" name="clientNumber" #clientNumber="ngModel" class="form-control" [(ngModel)]="model.clientNumber"
               required minlength="7" maxlength="8" />
        <div class="invalid-feedback" [mas-validation-message]="clientNumber"></div>
      </form-input>
    </fieldset>
    <div class="row">
      <div class="col-sm-6 text-left">
        <button type="button" class="btn btn-default" (click)="onPrevious()">Vorige</button>
      </div>
      <div class="col-sm-6 text-right">
        <button type="button" class="btn btn-primary" [attr.disabled]="mainForm.form.valid ? null : 'disabled'" (click)="onNext()">Verzenden</button>
      </div>
    </div>
  </form>
</model-page>
